<div class="sgt-produtividade-main-view sgt-view">
    <div class="row">
        <div class="col-12">
            <sgt-produtividade-classificacoes-kpi-widget
                #classificacoesWidget
                id="produtividadeMainViewClassificacoesWidget"
                title="Segmentos"
                subtitle="Produtividade por segmentos">
            </sgt-produtividade-classificacoes-kpi-widget>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <sgt-representante-produtividade-widget
                #representantesWidget
                id="produtividadeMainViewRepresentanteWidget"
                title="Representantes"
                subtitle="Produtividade por representantes">
            </sgt-representante-produtividade-widget>
        </div>
    </div>  
    
    <div class="row">
        <div class="col-12 col-xl-6">
            <sgt-representante-modalidade-comercial-faturamento-widget
                #modalidadesComerciaisFaturamentoWidget
                id="produtividadeMainViewRepresentanteModalidadeComercialFaturamentoWidget"
                title="Modalidades Comerciais"
                subtitle="Faturamento por modalidades comerciais">
            </sgt-representante-modalidade-comercial-faturamento-widget>
        </div>
    </div>      
</div>